import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_PROD_DEV_DOC_PENDING,
  GET_PROD_DEV_DOC,
  SG_GET_PROD_DEV_DOC,
  DELETE_PROD_DEV_DOC,
  SG_DELETE_PROD_DEV_DOC,
  FETCH_PROD_DEV_DOC,
  SG_FETCH_PROD_DEV_DOC,
  EDIT_PROD_DEV_DOC,
  SG_EDIT_PROD_DEV_DOC,
  ADD_PROD_DEV_DOC,
  SG_ADD_PROD_DEV_DOC,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";


function* loadprocess(action) {
  yield put({ type: GET_PROD_DEV_DOC_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_PROD_DEV_DOC, action.payload);
    yield put({ type: GET_PROD_DEV_DOC, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processLoad() {
  yield takeLatest(SG_GET_PROD_DEV_DOC, loadprocess);
}

function* fetchprocess(action) {
    yield put({ type: GET_PROD_DEV_DOC_PENDING });
  try {
    const json = yield call(api.FETCH_PROD_DEV_DOC, action.payload);
    yield put({ type: FETCH_PROD_DEV_DOC, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processFetch() {
  yield takeLatest(SG_FETCH_PROD_DEV_DOC, fetchprocess);
}

function* updateprocess(action) {
    yield put({ type: GET_PROD_DEV_DOC_PENDING });
  try {
    const json = yield call(api.EDIT_PROD_DEV_DOC, action.payload);
    yield put({ type: EDIT_PROD_DEV_DOC, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processUpdate() {
  yield takeLatest(SG_EDIT_PROD_DEV_DOC, updateprocess);
}

function* addprocess(action) {
    yield put({ type: GET_PROD_DEV_DOC_PENDING });
  try {
    const json = yield call(api.ADD_PROD_DEV_DOC, action.payload);
    yield put({ type: ADD_PROD_DEV_DOC, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processAdd() {
  yield takeLatest(SG_ADD_PROD_DEV_DOC, addprocess);
}

function* deleteprocess(action) {
  try {
    const json = yield call(api.DELETE_PROD_DEV_DOC, action.payload);
    yield put({ type: DELETE_PROD_DEV_DOC, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* processDelete() {
  yield takeLatest(SG_DELETE_PROD_DEV_DOC, deleteprocess);
}

export default function* index() {
  yield all([
    processLoad(),
    processFetch(),
    processUpdate(),
    processAdd(),
    processDelete(),
  ]);
}
